const CARFClassificationStatus = [
  { value: 1, name: 'Individual', description: 'Individual' },
  { value: 2, name: 'ReportableFIProManInvEnt', description: 'Reportable Financial Institution - Professionally Managed Investment Entity' },
  { value: 3, name: 'ExcludedFinancialInstitution', description: 'Excluded Financial Institution' },
  { value: 4, name: 'ExcludedRegTraded', description: 'Excluded Regularly Traded Entity' },
  { value: 5, name: 'ExcludedRegTradedRelated', description: 'Excluded Entity Related to a Regularly Traded Entity' },
  { value: 6, name: 'ExcludedGovernmentOrCentralBank', description: 'Excluded Government Entity or Central Bank' },
  { value: 7, name: 'ExcludedInternationalOrganization', description: 'Excluded International Organization' },
  { value: 8, name: 'ReportableActiveEntity', description: 'Reportable Active Entity' },
  { value: 9, name: 'ReportableOther', description: 'Reportable Other' },
  { value: 10, name: 'ControllingPerson', description: 'Controlling Person' },
];

export default CARFClassificationStatus;
